import { translateBackend } from '@assets/i18n/config';
import type { TranslatedString } from '@interfaces/shared';
import { getLanguageDefaults } from '@onevesthq/ov-translations';
import { CheckboxField } from '@ovComponents/2-component/checkboxField/checkboxField';
import { TranslatableTextField } from '@ovComponents/2-component/translatableTextField/translatableTextField';
import { Box } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';

type FieldEditProps = {
  option: any;
  options: any;
  setOptions: (x: any) => void;
  i: number;
};
const I18N_PREFIX =
  'workflowCompletions:subStepOptions.optionTypes.ADDITIONAL_INFO_FIELD';

export const additionalInfo = (additionalInfoOpts: any) => {
  if (additionalInfoOpts?.checked) return translateBackend(additionalInfoOpts);
  return undefined;
};

export const AdditionalInfoEdit = (props: FieldEditProps) => {
  const { option, options, setOptions, i } = props;
  const { t } = useTranslation(['workflowCompletions']);

  const additionalInfoOpts = option?.value?.additionalInfo ?? {
    checked: false,
    ...getLanguageDefaults(),
  };

  // Helper function to encapsulate verbose references when
  // updating options[field].value.selectField
  const updateAdditionalInfoOptions = (opts: object) => {
    const newOptions = [...options];
    newOptions[i].value = {
      ...option.value,
      additionalInfo: {
        ...additionalInfoOpts,
        ...opts,
      },
    };
    setOptions(newOptions);
  };

  const handleChecked = (onoff: boolean) => {
    updateAdditionalInfoOptions({ checked: onoff });
  };

  const handleTextChange = (value: TranslatedString) => {
    updateAdditionalInfoOptions(value);
  };

  return (
    <Box>
      <CheckboxField
        size='small'
        label={t(`${I18N_PREFIX}.checkboxLabel`)}
        checked={additionalInfoOpts.checked}
        onChange={handleChecked}
      />
      {additionalInfoOpts.checked && (
        <TranslatableTextField
          value={option?.value?.additionalInfo}
          dialogLabel={t(`${I18N_PREFIX}.checkboxLabel`)}
          fullWidth
          multiline
          rows={3}
          onChange={handleTextChange}
          allowMarkdown={true}
        />
      )}
    </Box>
  );
};
